import { render } from "./traditional.vue?vue&type=template&id=3fc11278&ts=true"
import script from "./traditional.vue?vue&type=script&lang=ts"
export * from "./traditional.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__